import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 6 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 9\" id=\"chevron-right\"><path fill=\"currentColor\" d=\"M.068.83l.96-.859.48.43 3.466 3.094.48.43.613.546-.48.43-4.078 3.641-.48.43-.962-.859.48-.43 3.598-3.212-.132-.117L.548 1.259z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol